import React, { useEffect, useState } from 'react'

import { arrayOf, node, number, string, bool, func } from 'prop-types'

import { useSwipeable } from 'react-swipeable'

const TmvnCarousel = ({
  id,
  items,
  autoInterval,
  indicators,
  activeItm,
  sideEffect,
  controlled,
}) => {
  const [activeIdx, setActiveIdx] = useState(activeItm || 0)
  const [autoSlide, setAutoSlide] = useState(true)

  let slideTimeout = null
  let pausedTimeout = null

  const swipedLeft = () => {
    if (activeIdx < items.length - 1) {
      setActiveIdx(activeIdx + 1)
    } else {
      setActiveIdx(0)
    }
  }
  const swipeRight = () => {
    if (activeIdx > 0) {
      setActiveIdx(activeIdx - 1)
    } else {
      setActiveIdx(items.length - 1)
    }
  }
  const handlers = useSwipeable({
    onSwipedRight: () => {
      setAutoSlide(false)
      swipeRight()
    },
    onSwipedLeft: () => {
      setAutoSlide(false)
      swipedLeft()
    },
    trackMouse: true,
  })

  useEffect(() => {
    sideEffect && sideEffect(activeIdx)
    if (controlled && activeItm !== activeIdx) {
      setActiveIdx(activeItm)
    }
    if (document) {
      const carouselEl = document.getElementById(id)
      const scrollSize = carouselEl && document.getElementById(id).offsetWidth
      carouselEl && document.getElementById(id).scroll({
        left: activeIdx * scrollSize,
        behavior: 'smooth',
      })
      if (autoInterval && autoSlide) {
        slideTimeout = setTimeout(() => swipedLeft(), autoInterval)
      }
    }
    if (!autoSlide) {
      clearTimeout(slideTimeout)
      clearTimeout(pausedTimeout)
      pausedTimeout = setTimeout(() => {
        setAutoSlide(true)
      }, autoInterval * 3)
    }
  })

  return (
    <div className="tmvn-carousel">
      <div
        id={id}
        className="tmvn-carousel__items"
        {...handlers}
      >
        {items.map((item, idx) => (
          <div className="tmvn-carousel__item" key={`itm-${idx}`}>
            {item}
          </div>
        ))}
      </div>
      {
        (indicators && items.length > 1) &&
        <div className="tmvn-carousel__indicator">
          {items.map((txt, idx) => (
            <div
              onClick={() => {
                setActiveIdx(idx)
                setAutoSlide(false)
              }}
              className={`
                tmvn-carousel__indicator-item
                ${activeIdx === idx && 'active'}
              `}
              key={`txt-itm-${idx}`}
            />
          ))}
        </div>
      }

      <style jsx>
        {`
          .tmvn-carousel {
            display: flex;
            flex-direction: column;
            height: 100%;
            &__items {
              display: flex;
              overflow: hidden;
              height: 100%;
            }
            &__item {
              min-width: 100%;
              display: flex;
              align-items: center;
            }
            &__indicator {
              display: flex;
              justify-content: center;
              padding: 16px;
            }
            &__indicator-item {
              width: 12px;
              height: 12px;
              margin: 4px;
              background-color: #ccc;
              border-radius: 100%;
              cursor: pointer;
              &.active {
                background-color: #0fc3c4;
              }
            }
          }
        `}
      </style>
    </div>
  )
}

TmvnCarousel.propTypes = {
  items: arrayOf(node),
  autoInterval: number,
  id: string.isRequired,
  indicators: bool,
  activeItm: number,
  sideEffect: func,
  controlled: bool,
}
TmvnCarousel.defaultProps = {
  indicators: true,
  controlled: false,
}

export default TmvnCarousel
